export function PlayIcon({
  className = "size-12",
}: {
  className?: string;
}) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M9.31252 44.9999C10.3288 44.9999 11.2141 44.6201 12.3039 43.9946L40.5906 27.6302C42.6563 26.4109 43.5037 25.4959 43.5037 24.0119C43.5037 22.528 42.6563 21.613 40.5906 20.4176L12.3039 4.03348C11.2141 3.40362 10.3288 3.04788 9.31252 3.04788C7.36341 3.04788 6 4.52603 6 6.89521V41.1328C6 43.5021 7.36341 44.9999 9.31252 44.9999Z" fill="white" />
    </svg>
  );
}
export const displayName = "PlayIcon";
